"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true
  });
  return <section ref={ref} className={`bg-primary text-white py-16 md:py-24 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 tracking-tight">
          Kontaktirajte nas
        </h1>
        <p className="text-lg md:text-xl font-default text-white/80 max-w-2xl mx-auto leading-relaxed">
          Imate pitanja o našim uslugama ili želite zatražiti demo? Naš tim stručnjaka je tu da vam pomogne unaprijediti vašu sigurnost i produktivnost.
        </p>
      </div>
    </section>;
}